import React from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./AddAdmin.module.scss";

import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { inviteAdmin } from "../../../../helpers/service";

const AddLocationSchema = yup.object().shape({
  email: yup.string().required("Required"),
});

const AddAdmin = ({ openModal, toggle, setInvitedOpen, setLoading }) => {
  const authData = useSelector((state) => state?.authReducer);

  const initialState = {
    email: "",
  };

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: true,
    validationSchema: AddLocationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const data = {
        adminEmail: authData.email,
        inviteeEmail: values.email,
      };
      const response = await inviteAdmin(data, authData?.idToken);
      
      if (response?.message) {
        setLoading(false);
        setInvitedOpen(true);
        toggle();
        formik.resetForm();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Modal
      isOpen={openModal}
      toggle={() => {
        formik.resetForm();
        toggle();
      }}
      centered
      fullscreen="sm"
      contentClassName={styles["modal_content"]}
      className={styles["container"]}
      wrapClassName={styles["modal_wrapper"]}
      backdropClassName={styles["modal-backdrop-style"]}
    >
      <ModalBody className={styles["modal_body"]}>
        <div>
          <p className={styles["heading"]}>Add admin</p>
          <p className={styles["descriptiondiv"]}>
            Enter the email address of your new Lumi Admin. Warning: Admins can
            see and edit the entire LumiRx database. Only send this invite to a
            trusted and authorized employee.
          </p>
        </div>
        <>
          <form
            onSubmit={formik.handleSubmit}
            className={styles["form_wrapper"]}
          >
            <div className={styles["form-group"]}>
              <input
                type="email"
                className={styles["input"]}
                id="email"
                name="email"
                placeholder="Email, comma separated"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className={styles["error"]}>{formik.errors.email}</div>
              ) : null}
            </div>
            <div className={styles["button-container"]}>
              <button
                type="submit"
                className={styles["button"]}
                disabled={formik.isSubmitting}
              >
                Add Admin
              </button>
            </div>
          </form>
        </>
      </ModalBody>
    </Modal>
  );
};

export default AddAdmin;
